import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

export const getAllOrders = createAsyncThunk(
    "orders/getAllOrders",
    async (_, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.get(
                apiEndpoints.getAllOrders,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getAllMusicCreatorOrders = createAsyncThunk(
    "orders/getAllMusicCreatorOrders",
    async (_, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.get(
                apiEndpoints.getAllMusicCreatorOrders,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getOrderById = createAsyncThunk(
    "orders/getOrderById",
    async (orderId, { rejectWithValue }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.get(
                apiEndpoints.getOrderById.replace("{order_id}", orderId),
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getClientOrderById = createAsyncThunk(
    "orders/getClientOrderById",
    async (orderId, { rejectWithValue }) => {
        try {

            const response = await axios.get(
                apiEndpoints.getClientOrderById.replace("{order_id}", orderId),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const uploadLyrics = createAsyncThunk(
    "orders/uploadLyrics",
    async ({ payload, orderId }, { rejectWithValue }) => {
        try {

            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.post(
                apiEndpoints.uploadLyrics.replace("{order_id}", orderId),
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const editLyrics = createAsyncThunk(
    "orders/editLyrics",
    async (payload, { rejectWithValue }) => {
        try {

            // Get token from localStorage
            const token = localStorage.getItem("token"); // replace "token" if your key is different

            const response = await axios.post(
                apiEndpoints.editLyrics,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const approveLyrics = createAsyncThunk(
    "orders/approveLyrics",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                apiEndpoints.approveLyrics,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const enableEditingLyrics = createAsyncThunk(
    "orders/enableEditingLyrics",
    async (payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(
                apiEndpoints.enableEditingLyrics,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const addLyricsComment = createAsyncThunk(
    "orders/addLyricsComment",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                apiEndpoints.addLyricsComment,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);
export const changeOrderStatus = createAsyncThunk(
    "orders/changeOrderStatus",
    async (payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.post(
                apiEndpoints.changeOrderStatus,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);
export const assignOrder = createAsyncThunk(
    "orders/assignOrder",
    async (payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.post(
                apiEndpoints.assignOrder,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const createManualOrder = createAsyncThunk(
    "orders/createManualOrder",
    async (payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.post(
                apiEndpoints.createManualOrder,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const editOrder = createAsyncThunk(
    "orders/editOrder",
    async (payload, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.post(
                apiEndpoints.editOrder,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getLyrics = createAsyncThunk(
    "orders/getLyrics",
    async (orderId, { rejectWithValue }) => {
        try {

            // Get token from localStorage

            const response = await axios.get(
                apiEndpoints.getLyrics.replace("{order_id}", orderId),
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const getDashboardCount = createAsyncThunk(
    "orders/dashboardCount",
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(
                apiEndpoints.dashboardCount,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        } catch (error) {
            // Capture API or network errors
            return rejectWithValue(
                error.response?.data || { detail: "Something went wrong" }
            );
        }
    }
);

export const clientSubmitOrderDetails = createAsyncThunk(
    "orders/clientSubmitOrderDetails",
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("token");

            const headers = {
                "Content-Type": "application/json",
            };

            //   if (requiresAuth) {
            //     headers.Authorization = `Bearer ${token}`;
            //   }

            const response = await axios.post(
                apiEndpoints.clientEditOrder.replace("{order_id}", id),
                payload,
                { headers }
            );

            return response.data;
        } catch (error) {
            console.log("e1", error)
            return rejectWithValue(error.response?.data || { detail: "Something went wrong" });
        }
    }
);

// ✅ Slice definition
const ordersSlice = createSlice({
    name: "orders",
    initialState: {
        loading: false,
        success: false,
        fetchError: null,
        ordersData: [],
        musicCreatorOrdersordersData: [],
        orderByIdData: [],
        clientOrderByIdData: [],
        uploadLyricsResponse: null,
        lyricsData: {},
        approveLyricsResponse: {},
        enableEditingLyricsResponse: {},
        addLyricsCommentResponse: {},
        changeOrderStatusResponse: {},
        assignOrderResponse: {},
        manualOrderResponse: {},
        dashboardCountResponse: {},
        editOrderResponse: {},
        clientSubmitOrderDetailsResponse: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllOrders.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getAllOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.ordersData = action.payload;
            })
            .addCase(getAllOrders.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getOrderById.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getOrderById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.orderByIdData = action.payload;
            })
            .addCase(getOrderById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getClientOrderById.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getClientOrderById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.clientOrderByIdData = action.payload;
            })
            .addCase(getClientOrderById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(uploadLyrics.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(uploadLyrics.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.uploadLyricsResponse = action.payload;
            })
            .addCase(uploadLyrics.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getLyrics.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getLyrics.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.lyricsData = action.payload;
            })
            .addCase(getLyrics.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(approveLyrics.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(approveLyrics.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.approveLyricsResponse = action.payload;
            })
            .addCase(approveLyrics.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(enableEditingLyrics.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(enableEditingLyrics.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.approveLyricsResponse = action.payload;
            })
            .addCase(enableEditingLyrics.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(addLyricsComment.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(addLyricsComment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.addLyricsCommentResponse = action.payload;
            })
            .addCase(addLyricsComment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(changeOrderStatus.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(changeOrderStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.changeOrderStatusResponse = action.payload;
            })
            .addCase(changeOrderStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(assignOrder.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(assignOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.assignOrderResponse = action.payload;
            })
            .addCase(assignOrder.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getAllMusicCreatorOrders.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getAllMusicCreatorOrders.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.musicCreatorOrdersordersData = action.payload;
            })
            .addCase(getAllMusicCreatorOrders.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(createManualOrder.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(createManualOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.manualOrderResponse = action.payload;
            })
            .addCase(createManualOrder.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(getDashboardCount.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(getDashboardCount.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.dashboardCountResponse = action.payload;
            })
            .addCase(getDashboardCount.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(editOrder.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
            })
            .addCase(editOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.editOrderResponse = action.payload;
            })
            .addCase(editOrder.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            })
            .addCase(clientSubmitOrderDetails.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.fetchError = null;
                state.clientSubmitOrderDetailsResponse = null;
            })
            .addCase(clientSubmitOrderDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.clientSubmitOrderDetailsResponse = action.payload;

                // optionally update orderByIdData so UI locks instantly without refetch:
                if (state.orderByIdData) {
                    state.orderByIdData = {
                        ...state.orderByIdData,
                        ...action.meta.arg.payload,
                        client_form_submitted: true,
                    };
                }
            })
            .addCase(clientSubmitOrderDetails.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.fetchError = action.payload?.detail || "Submission failed";
            });
    },
});

// ✅ Export actions and reducer

export default ordersSlice.reducer;